import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from 'commons/src/api/baseQuery';

export type WellReportRequest = {
    locationId: string;
    from: string;
    to: string;
    devices: number[];
};

export type WellReportResponse = {
    reportId?: string;
    locationId: string;
    message?: string;
};

export const wellReportApi = createApi({
    reducerPath: 'wellReportApi',
    baseQuery,
    tagTypes: ['WellReport'],
    endpoints: builder => ({
        generateWellReport: builder.mutation<WellReportResponse, WellReportRequest>({
            query: ({ locationId, ...body }) => ({
                url: `/locations/${locationId}/reports/well`,
                method: 'POST',
                data: body,
            }),
        }),
    }),
});

export const { useGenerateWellReportMutation } = wellReportApi;
